(() => {
  const root = document.querySelector("[data-rm-header]");
  if (!root) return;

  const body = document.body;
  const desktopQuery = window.matchMedia("(min-width: 921px)");
  const mobileSearchQuery = window.matchMedia("(max-width: 920px)");

  const collectionFilters = [
    { title: "Amity", material: "Amity", description: "Heart · Connection · Warmth" },
    { title: "Arc", material: "Arc", description: "Organic · Pearl" },
    { title: "Drift", material: "Drift", description: "Movement · Flow" },
    { title: "Reflection", material: "Reflection", description: "Mirror · Self · Presence" },
    { title: "Talisman", material: "Talisman", description: "Celestial · Lucky Charm · Energy" },
    { title: "Tide", material: "Tide", description: "Moon · Ocean · Calm" }
  ];

  const getProductBaseUrl = () => {
    const typedLink = root.querySelector('.rm-nav__item--shop a[href*="?type="]');
    const shopAllLink = root.querySelector('.rm-nav__item--shop a[href^="/collections/"]');
    const href = typedLink?.getAttribute("href") || shopAllLink?.getAttribute("href") || "/collections/all";
    return href.split("?")[0] || "/collections/all";
  };

  const createIcon = (direction = "right") => {
    const icon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    icon.setAttribute("class", "icon");
    icon.setAttribute("viewBox", "0 0 20 20");
    icon.setAttribute("fill", "none");
    icon.setAttribute("aria-hidden", "true");

    const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute("d", direction === "left" ? "M16 10H4m6 6-6-6 6-6" : "M4 10h12M10 4l6 6-6 6");
    path.setAttribute("stroke", "currentColor");
    path.setAttribute("stroke-width", "1.6");
    path.setAttribute("stroke-linecap", "round");
    path.setAttribute("stroke-linejoin", "round");
    icon.append(path);

    return icon;
  };

  const createNavLink = ({ href, title, description = "", stage = false }) => {
    const link = document.createElement("a");
    link.className = stage ? "rm-nav-link rm-nav-link--stage" : "rm-nav-link";
    link.href = href;

    const copy = document.createElement("span");
    copy.className = "rm-nav-link__copy";

    const titleNode = document.createElement("span");
    titleNode.className = "rm-nav-link__title";
    titleNode.textContent = title;
    copy.append(titleNode);

    if (description) {
      const descriptionNode = document.createElement("span");
      descriptionNode.className = "rm-nav-link__description";
      descriptionNode.textContent = description;
      copy.append(descriptionNode);
    }

    link.append(copy, createIcon());
    return link;
  };

  const createHeading = (text) => {
    const heading = document.createElement("p");
    heading.className = "rm-nav__heading";
    heading.textContent = text;
    return heading;
  };

  const createCollectionLinks = () => {
    const productBaseUrl = getProductBaseUrl();
    return collectionFilters.map(({ title, material, description }) =>
      createNavLink({
        href: `${productBaseUrl}?material=${encodeURIComponent(material)}`,
        title,
        description
      })
    );
  };

  const findColumnByHeading = (container, headingText) =>
    [...container.querySelectorAll(".rm-nav__column")].find(
      (column) => column.querySelector(".rm-nav__heading")?.textContent.trim() === headingText
    );

  const createDesktopCollectionColumn = () => {
    const column = document.createElement("section");
    column.className = "rm-nav__column rm-nav__column--collections";

    const list = document.createElement("div");
    list.className = "rm-nav__list";
    createCollectionLinks().forEach((link) => list.append(link));

    column.append(createHeading("Collections"), list);
    return column;
  };

  const createMobileRootButton = (target, label) => {
    const button = document.createElement("button");
    button.className = "rm-mobile-nav__root-link";
    button.type = "button";
    button.dataset.rmMobilePanelOpen = target;

    const labelNode = document.createElement("span");
    labelNode.textContent = label;
    button.append(labelNode, createIcon());
    return button;
  };

  const createMobilePanel = (name, title, backTarget, links) => {
    const view = document.createElement("div");
    view.className = "rm-mobile-nav__view";
    view.dataset.rmMobileView = name;
    view.hidden = true;

    const head = document.createElement("div");
    head.className = "rm-mobile-nav__panel-head";

    const back = document.createElement("button");
    back.className = "rm-mobile-nav__back";
    back.type = "button";
    back.dataset.rmMobilePanelBack = backTarget;

    const backText = document.createElement("span");
    backText.textContent = "Back";
    back.append(createIcon("left"), backText);

    const titleNode = document.createElement("span");
    titleNode.textContent = title;
    head.append(back, titleNode);

    const list = document.createElement("div");
    list.className = "rm-mobile-nav__list";
    links.forEach((link) => list.append(link));

    view.append(head, list);
    return view;
  };

  const normalizeShopByCollectionsNav = () => {
    const shopInner = root.querySelector(".rm-nav__item--shop .rm-nav__mega-inner");
    if (shopInner && !shopInner.querySelector(".rm-nav__column--category")) {
      const stageColumn = findColumnByHeading(shopInner, "Shop by Stage");
      const oldCollectionsColumn = findColumnByHeading(shopInner, "Collections");

      if (stageColumn && oldCollectionsColumn) {
        stageColumn.classList.add("rm-nav__column--stage");
        oldCollectionsColumn.classList.add("rm-nav__column--category");
        oldCollectionsColumn.querySelector(".rm-nav__heading").textContent = "Category";
        shopInner.insertBefore(createDesktopCollectionColumn(), oldCollectionsColumn);
      }
    }

    const shopView = root.querySelector('[data-rm-mobile-view="shop"]');
    const existingMobileCollections = root.querySelector('[data-rm-mobile-view="collections"]');
    const existingMobileCategory = root.querySelector('[data-rm-mobile-view="category"]');

    if (shopView && existingMobileCollections && !existingMobileCategory) {
      const oldCollectionsButton = shopView.querySelector('[data-rm-mobile-panel-open="collections"]');
      if (oldCollectionsButton) {
        oldCollectionsButton.insertAdjacentElement("afterend", createMobileRootButton("category", "Category"));
      }

      existingMobileCollections.dataset.rmMobileView = "category";
      const categoryHeading = existingMobileCollections.querySelector(".rm-mobile-nav__panel-head > span");
      if (categoryHeading) categoryHeading.textContent = "Category";

      const collectionsView = createMobilePanel("collections", "Collections", "shop", createCollectionLinks());
      existingMobileCollections.insertAdjacentElement("beforebegin", collectionsView);
    }

    root.dataset.rmNavBuild = root.dataset.rmNavBuild || "collections-20260617-js";
  };

  normalizeShopByCollectionsNav();

  const mobileToggle = root.querySelector("[data-rm-mobile-toggle]");
  const mobileDrawer = root.querySelector("[data-rm-mobile-drawer]");
  const mobileViews = [...root.querySelectorAll("[data-rm-mobile-view]")];
  const desktopItems = [...root.querySelectorAll("[data-rm-nav-item]")];
  const desktopCloseTimers = new Map();
  let mobileSearchViewportFrame = 0;
  let mobileNavMetricsFrame = 0;
  let desktopGlassFrame = 0;

  const getMobileViewportHeight = () =>
    Math.round(
      window.visualViewport?.height ||
      window.innerHeight ||
      document.documentElement.clientHeight ||
      0
    );

  const setHeaderScrolled = () => {
    root.classList.toggle("is-scrolled", window.scrollY > 24);
  };

  const updateMobileSearchViewport = () => {
    mobileSearchViewportFrame = 0;

    if (!mobileSearchQuery.matches) {
      document.documentElement.style.removeProperty("--rm-mobile-visual-height");
      return;
    }

    const viewportHeight = getMobileViewportHeight();

    if (viewportHeight > 0) {
      document.documentElement.style.setProperty("--rm-mobile-visual-height", `${viewportHeight}px`);
    }
  };

  const scheduleMobileSearchViewportUpdate = () => {
    if (mobileSearchViewportFrame) return;
    mobileSearchViewportFrame = window.requestAnimationFrame(updateMobileSearchViewport);
  };

  const updateMobileNavMetrics = () => {
    mobileNavMetricsFrame = 0;

    if (!mobileSearchQuery.matches) {
      document.documentElement.style.removeProperty("--rm-mobile-nav-panel-top");
      return;
    }

    const announcementBottom = root.querySelector(".announcement-bar")?.getBoundingClientRect().bottom || 0;
    const panelTop = Math.max(0, Math.ceil(announcementBottom));
    document.documentElement.style.setProperty("--rm-mobile-nav-panel-top", `${panelTop}px`);
  };

  const scheduleMobileNavMetricsUpdate = () => {
    if (mobileNavMetricsFrame) return;
    mobileNavMetricsFrame = window.requestAnimationFrame(updateMobileNavMetrics);
  };

  const updateDesktopGlass = () => {
    desktopGlassFrame = 0;

    const item = desktopItems.find((entry) => entry.classList.contains("is-open"));
    const bar = root.querySelector(".rm-header__bar");
    const panel = item?.querySelector(".rm-nav__mega");

    if (!desktopQuery.matches || root.classList.contains("is-scrolled") || !bar || !panel) {
      root.classList.remove("rm-nav-glass-open");
      root.style.removeProperty("--rm-nav-glass-top");
      root.style.removeProperty("--rm-nav-glass-height");
      return;
    }

    const rootRect = root.getBoundingClientRect();
    const barRect = bar.getBoundingClientRect();
    const panelRect = panel.getBoundingClientRect();
    const height = Math.ceil(panelRect.bottom - barRect.top);

    if (height <= 0) {
      root.classList.remove("rm-nav-glass-open");
      root.style.removeProperty("--rm-nav-glass-top");
      root.style.removeProperty("--rm-nav-glass-height");
      return;
    }

    root.style.setProperty("--rm-nav-glass-top", `${Math.round(barRect.top - rootRect.top)}px`);
    root.style.setProperty("--rm-nav-glass-height", `${height}px`);
    root.classList.add("rm-nav-glass-open");
  };

  const scheduleDesktopGlassUpdate = () => {
    if (desktopGlassFrame) return;
    desktopGlassFrame = window.requestAnimationFrame(updateDesktopGlass);
  };

  const clearDesktopTimer = (item) => {
    const timer = desktopCloseTimers.get(item);
    if (!timer) return;
    window.clearTimeout(timer);
    desktopCloseTimers.delete(item);
  };

  const setDesktopItem = (item, open) => {
    clearDesktopTimer(item);
    item.classList.toggle("is-open", open);
    item.querySelector("[data-rm-nav-toggle]")?.setAttribute("aria-expanded", open ? "true" : "false");
    scheduleDesktopGlassUpdate();
  };

  const closeDesktopMenus = (except = null) => {
    desktopItems.forEach((item) => {
      if (item === except) return;
      setDesktopItem(item, false);
    });
  };

  const openDesktopMenu = (item) => {
    closeDesktopMenus(item);
    setDesktopItem(item, true);
  };

  const scheduleDesktopClose = (item) => {
    clearDesktopTimer(item);
    desktopCloseTimers.set(
      item,
      window.setTimeout(() => {
        if (!item.matches(":hover, :focus-within")) setDesktopItem(item, false);
      }, 130)
    );
  };

  const setMobileView = (name = "root") => {
    mobileViews.forEach((view) => {
      const active = view.dataset.rmMobileView === name;
      view.hidden = !active;
      view.classList.toggle("is-active", active);
    });
  };

  const setMobileNav = (open) => {
    if (open) updateMobileNavMetrics();
    body.classList.toggle("rm-nav-open", open);
    mobileToggle?.setAttribute("aria-expanded", open ? "true" : "false");
    mobileToggle?.setAttribute("aria-label", open ? "Close navigation" : "Open navigation");
    mobileDrawer?.setAttribute("aria-hidden", open ? "false" : "true");
    if (!open) {
      setMobileView("root");
    } else {
      closeDesktopMenus();
    }
  };

  desktopItems.forEach((item) => {
    const toggle = item.querySelector("[data-rm-nav-toggle]");
    if (!toggle) return;

    toggle.addEventListener("click", () => {
      if (!desktopQuery.matches) return;
      openDesktopMenu(item);
    });

    item.addEventListener("mouseenter", () => {
      if (!desktopQuery.matches) return;
      openDesktopMenu(item);
    });

    item.addEventListener("mouseleave", () => {
      if (!desktopQuery.matches) return;
      scheduleDesktopClose(item);
    });

    item.addEventListener("focusin", () => {
      if (!desktopQuery.matches) return;
      openDesktopMenu(item);
    });

    item.addEventListener("focusout", (event) => {
      if (!desktopQuery.matches) return;
      if (event.relatedTarget && item.contains(event.relatedTarget)) return;
      scheduleDesktopClose(item);
    });
  });

  mobileToggle?.addEventListener("click", () => {
    setMobileNav(!body.classList.contains("rm-nav-open"));
  });

  root.querySelectorAll("[data-rm-mobile-close]").forEach((button) => {
    button.addEventListener("click", () => setMobileNav(false));
  });

  root.querySelectorAll("[data-rm-mobile-panel-open]").forEach((button) => {
    button.addEventListener("click", () => setMobileView(button.dataset.rmMobilePanelOpen || "root"));
  });

  root.querySelectorAll("[data-rm-mobile-panel-back]").forEach((button) => {
    button.addEventListener("click", () => setMobileView(button.dataset.rmMobilePanelBack || "root"));
  });

  const bindSearchEnhancements = () => {
    const searchInput = document.querySelector("[data-predictive-search-input]");
    const searchClear = document.querySelector("[data-predictive-search-clear]");
    const getSearchDrawer = () => document.querySelector('[data-drawer="search"]');
    if (!searchInput || !searchClear) return;

    const bindMobileProductScroller = () => {
      document.querySelectorAll(".predictive-search__mobile-products").forEach((track) => {
        if (track.dataset.rmDragBound === "true") return;
        track.dataset.rmDragBound = "true";

        let isDragging = false;
        let didMove = false;
        let suppressClick = false;
        let startX = 0;
        let startScrollLeft = 0;

        const endDrag = () => {
          if (!isDragging) return;
          isDragging = false;
          track.classList.remove("is-dragging");
          if (didMove) {
            suppressClick = true;
            window.setTimeout(() => {
              suppressClick = false;
            }, 140);
          }
        };

        track.addEventListener("pointerdown", (event) => {
          isDragging = true;
          didMove = false;
          startX = event.clientX;
          startScrollLeft = track.scrollLeft;
          track.classList.add("is-dragging");
          track.setPointerCapture?.(event.pointerId);
        });

        track.addEventListener("pointermove", (event) => {
          if (!isDragging) return;
          const deltaX = event.clientX - startX;
          if (Math.abs(deltaX) > 4) didMove = true;
          track.scrollLeft = startScrollLeft - deltaX;
          if (didMove) event.preventDefault();
        });

        track.addEventListener("pointerup", endDrag);
        track.addEventListener("pointercancel", endDrag);
        track.addEventListener("pointerleave", endDrag);
        track.addEventListener("click", (event) => {
          if (!suppressClick) return;
          event.preventDefault();
          event.stopPropagation();
        });
      });
    };

    const syncSearchDrawerState = () => {
      const searchDrawer = getSearchDrawer();
      const isSearchOpen = Boolean(searchDrawer?.classList.contains("is-open"));
      body.classList.toggle("rm-search-open", isSearchOpen);
      if (isSearchOpen) scheduleMobileSearchViewportUpdate();
    };

    const syncSearchClear = () => {
      const hasQuery = searchInput.value.trim().length > 0;
      searchClear.hidden = !hasQuery && !mobileSearchQuery.matches;
      getSearchDrawer()?.classList.toggle("has-search-query", hasQuery);
      syncSearchDrawerState();
    };

    searchInput.addEventListener("input", syncSearchClear);
    mobileSearchQuery.addEventListener?.("change", syncSearchClear);
    searchClear.addEventListener("click", (event) => {
      event.preventDefault();
      searchInput.value = "";
      searchInput.dispatchEvent(new Event("input", { bubbles: true }));
      syncSearchClear();
      searchInput.focus();
    });

    document.querySelectorAll('[data-open-drawer="search"]').forEach((button) => {
      button.addEventListener("click", () => window.setTimeout(syncSearchClear, 0));
    });

    const searchDrawer = getSearchDrawer();
    if (searchDrawer) {
      const observer = new MutationObserver(syncSearchDrawerState);
      observer.observe(searchDrawer, {
        attributes: true,
        attributeFilter: ["class", "aria-hidden"]
      });
    }

    bindMobileProductScroller();
    syncSearchClear();
  };

  document.addEventListener("click", (event) => {
    if (!event.target.closest("[data-rm-header]")) closeDesktopMenus();
  });

  document.addEventListener("click", (event) => {
    const searchDrawer = document.querySelector('[data-drawer="search"].is-open');
    if (!searchDrawer) return;
    if (event.target.closest('[data-open-drawer="search"]')) return;
    if (mobileSearchQuery.matches && event.target.closest(".site-drawer__panel--search")) return;
    if (event.target.closest(".predictive-search")) return;
    searchDrawer.querySelector("[data-close-drawer]")?.click();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    closeDesktopMenus();
    setMobileNav(false);
  });

  window.addEventListener("resize", () => {
    if (desktopQuery.matches) setMobileNav(false);
    scheduleDesktopGlassUpdate();
    scheduleMobileSearchViewportUpdate();
    scheduleMobileNavMetricsUpdate();
  });

  window.visualViewport?.addEventListener("resize", () => {
    scheduleMobileSearchViewportUpdate();
    scheduleMobileNavMetricsUpdate();
  });
  window.visualViewport?.addEventListener("scroll", () => {
    scheduleMobileSearchViewportUpdate();
    scheduleMobileNavMetricsUpdate();
  });
  mobileSearchQuery.addEventListener?.("change", () => {
    scheduleMobileSearchViewportUpdate();
    scheduleMobileNavMetricsUpdate();
  });

  bindSearchEnhancements();
  updateMobileSearchViewport();
  updateMobileNavMetrics();
  setHeaderScrolled();
  scheduleDesktopGlassUpdate();
  window.addEventListener("scroll", () => {
    setHeaderScrolled();
    scheduleDesktopGlassUpdate();
  }, { passive: true });
})();
